module.exports = __webpack_public_path__ + "static/media/BarOgilvy.a920854d.jpg";